<template>
    <div class="w-full">
        <div>
            <div
                class="flex flex-wrap md:flex-nowrap items-end gap-3"
            >
                <label class="form-control w-full max-w-xs">
                    <div class="label">
                        <span class="label-text">Nume</span>
                    </div>
                    <input
                        type="text"
                        v-model="surname"
                        placeholder="Nume"
                        required
                        class="input input-bordered w-full max-w-xs"
                    />
                </label>

                <label class="form-control w-full max-w-xs">
                    <div class="label">
                        <span class="label-text">Prenume</span>
                    </div>
                    <input
                        type="text"
                        v-model="name"
                        placeholder="Prenume"
                        required
                        class="input input-bordered w-full max-w-xs"
                    />
                </label>

                <label class="form-control w-full max-w-xs">
                    <div class="label">
                        <span class="label-text">Mobil</span>
                    </div>
                    <input
                        type="text"
                        v-model="mobile"
                        placeholder="Mobil"
                        required
                        class="input input-bordered w-full max-w-xs"
                    />
                </label>

                <label class="form-control w-full max-w-xs">
                    <div class="label">
                        <span class="label-text">Email</span>
                    </div>
                    <input
                        type="email"
                        v-model="email"
                        placeholder="Email"
                        required
                        class="input input-bordered w-full max-w-xs"
                    />
                </label>

                <button
                    @click.prevent="addParticipant()"
                    class="btn btn-primary mt-6 md:mt-0 w-full md:w-auto"
                >
                    <font-awesome-icon icon="fa-solid fa-user-plus" />
                    Adaugă
                </button>
            </div>
        </div>
    </div>
</template>

<script>
import { useToast } from 'vue-toastification';
import { validateMobile, mobileFormatText } from '@/utils/mobileValidation';
import { mapGetters } from 'vuex';

export default {
    data() {
        return {
            name: '',
            surname: '',
            mobile: '',
            email: '',
            isAuthenticated: false,
            uniqueParameter: '',
            mobileFormatText: mobileFormatText,
        };
    },
    props: {
        projectId: {
            required: true,
        },
    },
    setup() {
        // Get toast interface
        const toast = useToast();

        // Make it available inside methods
        return { toast };
    },
    created() {},
    computed: {
        ...mapGetters(['scopedProjectData']),
    },
    methods: {
        checkMobileDuplicates() {
            return this.scopedProjectData.participants.some(
                (participant) => participant.recipient_mobile === this.mobile
            ); // true if found, false otherwise
        },
        checkEmailDuplicates() {
            return this.scopedProjectData.participants.some(
                (participant) => participant.recipient_email === this.email
            ); // true if found, false otherwise
        },
        async addParticipant() {
            if (this.checkMobileDuplicates()) {
                this.toast.error(
                    'Un invitat cu acelasi numar de mobil este deja adaugat.'
                );
                return;
            }

            if (this.checkEmailDuplicates()) {
                this.toast.error(
                    'Un invitat cu acelasi email este deja adaugat.'
                );
                return;
            }

            // Check if the mobile number matches the desired format
            if (!validateMobile(this.mobile)) {
                this.toast.error(
                    'Formatul numarului de telefon mobil nu este valid. Exemplu: 0712345678'
                );
                return;
            }

            // Assuming you have form data available in Vue data properties
            const formData = {
                name: this.name,
                surname: this.surname,
                mobile: this.mobile,
                email: this.email,
                projectId: this.projectId,
            };

            try {
                await this.$store.dispatch('addParticipant', formData);

                this.toast.success(
                    `${formData.name} a fost adaugat in lista de invitați!`
                );
            } catch (error) {
                this.toast.error(`A aparut o eroare.`);
            }
        },
    },
};
</script>

<style scoped>
/* No need to add additional styles here for Tailwind CSS */
</style>
